import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHousecallProRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 31 31",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#2096F3",
		d: "M16.7961 2.42627L16.814 2.44257C16.8546 2.56057 16.8313 3.78533 16.8313 3.99066L16.8311 7.96075L16.8346 28.7777C16.0777 28.4368 15.5735 28.1367 14.868 27.7604L11.389 25.9064C11.0204 25.7345 10.6809 25.5068 10.321 25.3301C9.70382 25.027 9.11263 24.685 8.50653 24.3667C8.47777 23.7896 8.50115 23.0082 8.50113 22.4165L8.50105 18.6208L8.5024 7.29439C8.94157 6.96323 9.3856 6.79281 9.83279 6.51286C10.3679 6.17788 10.8916 5.889 11.4352 5.57541L16.7961 2.42627Z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#2096F3",
		d: "M19.2402 5.21948L22.7649 5.22174C22.7348 6.09369 22.752 7.06704 22.7499 7.94786L22.732 12.4521L22.6954 26.3668L21.2397 26.3693L19.2454 26.3665L19.2433 24.3597L20.744 24.3612C20.7272 23.7786 20.744 23.1103 20.7452 22.5229L20.7636 18.4957L20.7996 7.22076C20.2922 7.23006 19.7551 7.22295 19.2456 7.22353C19.2476 6.55551 19.2458 5.8875 19.2402 5.21948Z"
	})]
});
export default SvgHousecallProRegularIcon;
